import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import {Box, Icon, Typography} from '@mui/material';
import AppCard from 'main/core/AppCard';
import AppIcon from 'main/core/AppLayout/components/AppIcon';
import AppLink from 'main/core/AppLink';
import PropTypes from 'prop-types';

const QuickLinkCard = ({data}) => {
  let icon = AppIcon[data.icon] || <OpenInNewOutlinedIcon />;
  return (
    <AppCard
      sxStyle={{
        height: '100%',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        border: '1px solid rgba(26, 26, 27, 0.05)', // Subtle Onyx border
        '&:hover': {
          borderColor: 'primary.main', // Gold border on hover
          boxShadow: '0px 10px 20px rgba(212, 175, 55, 0.1)',
          '& .nav-item-icon, & .link-text': {
            color: 'primary.dark', // Everything ignites Dark Gold together
            transition: 'color 0.3s ease',
          },
        },
      }}
      contentStyle={{
        py: 3,
        px: 2,
        '&:last-child': {paddingBottom: 3},
      }}
      className='card-hover'
    >
      <AppLink href={data.path} style={{textDecoration: 'none'}}>
        <Box sx={{display: 'flex', alignItems: 'center', flexDirection: 'row'}}>
          <Box sx={{mr: 4, ml: 2}}>
            <Icon
              className='nav-item-icon'
              sx={{
                color: 'secondary.main', // Default Onyx
                fontSize: 24, // Larger icon for better cockpit visual
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {icon}
            </Icon>
          </Box>
          <Box sx={{textAlign: 'left'}}>
            <Typography
              className='link-text'
              sx={{
                fontSize: 15,
                mb: 0,
                letterSpacing: '0.5px',
                '& a': {
                  textDecoration: 'none',
                  color: 'secondary.main',
                },
              }}
            >
              {data.title}
            </Typography>
          </Box>
        </Box>
      </AppLink>
    </AppCard>
  );
};

export default QuickLinkCard;

QuickLinkCard.propTypes = {
  data: PropTypes.object,
};
